// extracted by mini-css-extract-plugin
export default {"image":"e8-z","loaded":"f8-z"};